import React, { useEffect, useState } from "react";
import MainPage from "./pages/MainPage";
import Loader from "./components/common/Loader";
import { LoaderProvider } from "./contexts/LoaderContext";

function App() {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Start initialization
        if (window.ZOHO && ZOHO.embeddedApp) {
          await ZOHO.embeddedApp.init();
          console.log("ZOHO embedded app initialized ✅ From Quality App");
        } else {
          console.warn("ZOHO embeddedApp not available ⚠️");
        }
      } catch (err) {
        console.error("Error during initialization:", err);
      } finally {
        // Ensure loading state is cleared after timeout, regardless of errors
        setTimeout(() => {
          setInitialLoading(false);
          console.log("Loading completed, showing main application");
        }, 3500);
      }
    };

    initializeApp();

    // Add a safety timeout to prevent infinite loading
    const safetyTimeout = setTimeout(() => {
      if (initialLoading) {
        console.warn("Safety timeout triggered to prevent infinite loading");
        setInitialLoading(false);
      }
    }, 3000);

    return () => clearTimeout(safetyTimeout);
  }, []);

  // Debug log to see if we're stuck in loading state
  console.log("Current loading state:", initialLoading);

  if (initialLoading) {
    return <Loader message="Initializing Quality Management System..." />;
  }

  return (
    <LoaderProvider>
      <MainPage />
    </LoaderProvider>
  );
}
export default App;
